/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * Workflow execution status
 */
export type WorkflowStatus = (typeof WorkflowStatus)[keyof typeof WorkflowStatus];

export const WorkflowStatus = {
  ACTIVE: 'active',
  PAUSED: 'paused',
  ATTEMPTS_EXCEEDED: 'attempts_exceeded',
  DISABLED: 'disabled',
} as const;
